// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.third-party-button-light:disabled {
  cursor: default;
  background-color: rgba(255, 255, 255, 0.3803921569);
  border-color: rgba(31, 31, 31, 0.1215686275);
}

.third-party-button-light:disabled .third-party-button-contents-light,
.third-party-button-light:disabled .third-party-button-icon-light {
  opacity: 38%;
}

.third-party-button-light:not(:disabled):active .third-party-button-state-light,
.third-party-button-light:not(:disabled):focus .third-party-button-state-light {
  opacity: 12%;
}

.third-party-button-light:not(:disabled):hover {
  box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);
}

.third-party-button-light:not(:disabled):hover .third-party-button-state-light {
  opacity: 8%;
}

.third-party-button-dark:disabled {
  cursor: default;
  background-color: rgba(32, 33, 36, 0.3803921569);
  border-color: rgba(232, 234, 237, 0.1215686275);
}

.third-party-button-dark:disabled .third-party-button-contents-dark,
.third-party-button-dark:disabled .third-party-button-icon-dark {
  opacity: 38%;
}

.third-party-button-dark:not(:disabled):active .third-party-button-state-dark,
.third-party-button-dark:not(:disabled):focus .third-party-button-state-dark {
  opacity: 12%;
}

.third-party-button-dark:not(:disabled):hover {
  box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);
}

.third-party-button-dark:not(:disabled):hover .third-party-button-state-dark {
  opacity: 8%;
}`, "",{"version":3,"sources":["webpack://./src/components/authentication/social-third-party-login/third-party-button.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,mDAAA;EACA,4CAAA;AACF;;AAEA;;EAEE,YAAA;AACF;;AAEA;;EAEE,YAAA;AACF;;AAEA;EACE,mFAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,eAAA;EACA,gDAAA;EACA,+CAAA;AACF;;AAEA;;EAEE,YAAA;AACF;;AAEA;;EAEE,YAAA;AACF;;AAEA;EACE,mFAAA;AACF;;AAEA;EACE,WAAA;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
